import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next"; // Import the hook for localization
import { SectionDescription } from "components/misc/Typography.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import {
  Container,
  ContentWithVerticalPadding,
} from "components/misc/Layouts.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/dot-pattern.svg";
import buildingImg from "images/reinforcement/construction.png";
import BgTitle from "components/title/BgTitle";
import ReinforcementSystemMobileView from "./ReinforcementSystemMobileView";

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;

const Row = tw.div`flex flex-col lg:flex-row justify-between items-center lg:pt-16 max-w-screen-2xl mx-auto sm:px-8`;
const Column = tw.div``;
const TextColumn = tw(
  Column
)`mr-auto lg:mr-0 max-w-lg lg:max-w-xl xl:max-w-2xl`;
const Description = tw(SectionDescription)`mt-4 text-sm text-gray-700 max-w-lg`;
const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-8 bg-ncc inline-block w-32 tracking-wide text-center text-sm py-2 rounded-full`;
const ImageColumn = tw(Column)`ml-auto lg:mr-0 relative mt-16 lg:mt-0 lg:ml-32`;
const ImageContainer = tw.div`relative z-40 transform xl:-translate-x-24 xl:-translate-y-16`;
const Image = tw.img`max-w-full w-96 rounded-t sm:rounded relative z-20`;
const Offsetbackground = tw.div`absolute inset-0 bg-gray-300 rounded xl:-mb-8`;
const ImageDecoratorBlob = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none z-10 absolute right-0 bottom-0 transform translate-x-10 translate-y-10 h-32 w-32 opacity-25 text-gray-900 fill-current`}
`;
export default ({
  imageSrc = buildingImg,
  imageDecoratorBlob = true,
  primaryButtonUrl = "/business-reinforcement",
  buttonRounded = true,
  isXs = false,
}) => {
  if (isXs) return <ReinforcementSystemMobileView />;
  const { t } = useTranslation(); // Initialize translation hook

  const buttonRoundedCss = buttonRounded && tw`rounded-full`;
  return (
    <BgWrapper>
      <div id="reinforcement-system">
        <Container>
          <ContentWithVerticalPadding>
            <Row>
              <TextColumn>
                <BgTitle text={t("business.reinforcement.heading")} />
                <Description>
                  {t("business.reinforcement.description")}
                </Description>
                <PrimaryButton
                  as="a"
                  href={primaryButtonUrl}
                  css={buttonRoundedCss}
                >
                  {t("business.reinforcement.detailsBtn")}
                </PrimaryButton>
              </TextColumn>
              <ImageColumn>
                <ImageContainer>
                  <Image src={imageSrc} />
                  {imageDecoratorBlob && <ImageDecoratorBlob />}
                </ImageContainer>
                <Offsetbackground />
              </ImageColumn>
            </Row>
          </ContentWithVerticalPadding>
        </Container>
      </div>
    </BgWrapper>
  );
};
